import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path fill="#D8FFFF" d="M109.5 71a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M92.554 94.44a1.5 1.5 0 0 1 0 2.12l-9.993 9.994a1.501 1.501 0 0 1-2.121-2.122l9.992-9.993a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M80.44 94.44a1.5 1.5 0 0 1 2.12 0l9.994 9.992a1.501 1.501 0 0 1-2.122 2.122l-9.993-9.993a1.5 1.5 0 0 1 0-2.122"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      d="M43.475 17.089a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M9.566 10a1.5 1.5 0 0 1 1.5 1.5v14.134a1.5 1.5 0 0 1-3 0V11.5a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M1 18.567a1.5 1.5 0 0 1 1.5-1.5h14.133a1.5 1.5 0 0 1 0 3H2.5a1.5 1.5 0 0 1-1.5-1.5M8.672 68.537a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#D8FFFF"
      d="M40.306 63.044h-20.36a6.274 6.274 0 0 1-6.274-6.274V31.672a6.274 6.274 0 0 1 6.274-6.274H95.24a6.274 6.274 0 0 1 6.274 6.274V57.37a5.673 5.673 0 0 1-5.674 5.674z"
    />
    <circle cx={43.46} cy={45.82} r={3.82} fill="#001A43" />
    <circle cx={27.82} cy={45.82} r={3.82} fill="#001A43" />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M95.962 75.064a3 3 0 0 1 4.242 0l14.56 14.56a3 3 0 1 1-4.242 4.243l-14.56-14.56a3 3 0 0 1 0-4.243"
      clipRule="evenodd"
    />
    <path
      fill="#0597A3"
      d="M80.27 84.54c13.956 0 25.27-11.314 25.27-25.27S94.226 34 80.27 34 55 45.314 55 59.27s11.314 25.27 25.27 25.27"
    />
    <path
      fill="#00D8D8"
      d="M80.27 78.997c10.895 0 19.727-8.832 19.727-19.727S91.165 39.543 80.27 39.543 60.543 48.375 60.543 59.27s8.832 19.727 19.727 19.727"
    />
    <path
      fill="#D8FFFF"
      fillRule="evenodd"
      d="M78.02 45.766a2.25 2.25 0 0 1 2.25-2.25c5.994 0 11.203 3.349 13.864 8.266a2.25 2.25 0 0 1-3.958 2.142 11.25 11.25 0 0 0-9.906-5.908 2.25 2.25 0 0 1-2.25-2.25"
      clipRule="evenodd"
    />
  </svg>
);
const SvgEnrichedIconSeoBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconSeoBrand);
export default Memo;
